<template>
    <!-- Wraps a host's own template button (slot keeps its look): click = apply, hover = dropdown
         with apply (made explicit)/create/update, so the action is chosen before TemplatePicker opens -->
    <div class="template-trigger-menu" @mouseenter="onEnter" @mouseleave="onLeave">
        <div class="ttm-main" @click.stop="choose('apply')">
            <slot></slot>
        </div>

        <div class="ttm-dropdown" v-if="canSave && hover && !open" :class="`ttm-align-${align}`">
            <div class="ttm-option" @click.stop="choose('apply')">
                <i class="fa-regular fa-arrow-pointer"></i>
                {{ $t('dash.templates.menu.apply') }}
            </div>
            <div class="ttm-option" @click.stop="choose('create')">
                <i class="fa-regular fa-plus"></i>
                {{ $t('dash.templates.menu.create') }}
            </div>
            <div class="ttm-option" @click.stop="choose('update')">
                <i class="fa-regular fa-arrows-rotate"></i>
                {{ $t('dash.templates.menu.update') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TemplateTrigger',

    props: {
        // picker currently open: hides the dropdown so it doesn't linger above the popup
        open: {
            type: Boolean,
            default: false
        },
        // false where the host has nothing it could save (click still applies, no dropdown)
        canSave: {
            type: Boolean,
            default: true
        },
        // ms before the dropdown shows, e.g. to wait for a host's own hover animation to finish
        openDelay: {
            type: Number,
            default: 0
        },
        align: {
            type: String,
            default: 'left',
            validator: v => ['left', 'right'].includes(v)
        }
    },

    data() {
        return {
            hover: false,
            enterTimer: null,
            leaveTimer: null
        }
    },

    beforeDestroy() {
        clearTimeout(this.enterTimer)
        clearTimeout(this.leaveTimer)
    },

    methods: {
        onEnter() {
            clearTimeout(this.leaveTimer)
            if (this.hover) return
            clearTimeout(this.enterTimer)
            this.enterTimer = setTimeout(() => { this.hover = true }, this.openDelay)
        },

        // short delay so crossing the gap between button and dropdown doesn't close it
        onLeave() {
            clearTimeout(this.enterTimer)
            clearTimeout(this.leaveTimer)
            this.leaveTimer = setTimeout(() => { this.hover = false }, 150)
        },

        choose(action) {
            clearTimeout(this.enterTimer)
            this.hover = false
            this.$emit('open', action)
        }
    }
}
</script>

<style lang="scss" scoped>
.template-trigger-menu {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.ttm-main {
    display: inline-flex;
    align-items: center;
}

.ttm-dropdown {
    position: absolute;
    top: 100%;
    z-index: 30;
    margin-top: 4px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    padding: 4px;
    min-width: 200px;

    // invisible bridge over the margin gap so the pointer never "leaves" on the way down
    &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        height: 6px;
    }

    &.ttm-align-left { left: 0; }
    &.ttm-align-right { right: 0; }
}

.ttm-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    font-size: 12px;
    font-weight: 500;
    color: #303030;
    cursor: pointer;
    border-radius: 4px;
    white-space: nowrap;
    text-decoration: none;
    letter-spacing: normal;

    i {
        width: 12px;
        font-size: 11px;
        color: #B64985;
    }

    &:hover {
        background: #f5f6fa;
    }
}
</style>
